import { SafeOrder, SafeSortBy } from '../../types/safes.types';
import { localStorageUtil } from '../../utils/local-storage.util';

export const safesSortStore = localStorageUtil<{
  field: null | SafeSortBy;
  sortMode: null | SafeOrder;
}>('safesSortState');
